export const getPodsExcluding = (excluded: string[], pods: { podName: string }[]): string => {
  const allPodNames = pods.map(p => p.podName)
  const remaining = allPodNames.filter(p => !excluded.includes(p))
  return remaining.join(', ')
}
